import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./components/layout/Layout";
import HomePage from "./components/pages/Home";
import AboutPage from "./components/pages/About";
import ServicesPage from "./components/pages/Services";
import GalleryPage from "./components/pages/Gallery";
import ContactPage from "./components/pages/Contact";
import BookingPage from "./components/pages/Booking";
import ScrollToTop from "./components/utils/ScrollToTop";
import "./styles/global.css";

// Definirajte gtag funkciju izvan useEffect
const gtag = (...args: any[]): void => {
  window.dataLayer.push(args);
};

const App: React.FC = () => {
  useEffect(() => {
    const cookieConsent = localStorage.getItem("cookieConsent");
    if (cookieConsent) {
      const consent = JSON.parse(cookieConsent);

      // Postavite inicijalne postavke za Google Analytics i druge alate
      window.dataLayer = window.dataLayer || [];

      gtag("consent", "default", {
        analytics_storage: consent ? "granted" : "denied",
        ad_storage: consent ? "granted" : "denied",
      });
    }
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/booking" element={<BookingPage />} />
        </Routes>
      </Layout>
    </Router>
  );
};

export default App;
